import { Tabs as TabsPrimitive } from '@mui/material';
import classnames from 'classnames';
import { PropsWithChildren } from 'react';

import styles from './ToggleMenu.module.scss';
import { TabsProps } from './ToggleMenu.types';

export const ToggleMenu = <T extends string>({
  className,
  value,
  onChange,
  ...props
}: PropsWithChildren<TabsProps<T>>) => {
  return (
    <TabsPrimitive
      className={classnames(styles.toggleMenu, className)}
      value={value}
      variant="scrollable"
      scrollButtons={false}
      onChange={(_, value) => onChange(value)}
      {...props}
    />
  );
};
